<template>
  <div>
   <el-form ref="form" :model="ruleForm" label-width="100px">
         <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="安全条目编号" prop="XJTMBH">
               <span v-show="!edit">{{ ruleForm.XJTMBH }}</span>
              <el-input v-show="edit" v-model="ruleForm.XJTMBH" placeholder="请输入"></el-input>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="安全条目名称" prop="XJTMMC">
                <span v-show="!edit">{{ ruleForm.XJTMMC }}</span>
              <el-input v-show="edit" v-model="ruleForm.XJTMMC" placeholder="请输入"></el-input>
            </el-form-item>
            </div></el-col>
        </el-row>
       <el-row :gutter="20">
          <el-col :offset="1" :span="10"><div class="grid-content bg-purple">
            <el-form-item label="风险等级" prop="FXDJ">
                <span v-show="!edit">{{ ruleForm.FXDJ }}</span>
              <el-select v-show="edit" v-model="ruleForm.FXDJ" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
            </el-form-item>
            </div></el-col>
          <el-col :span="10" ><div class="grid-content bg-purple">
             <el-form-item label="上级安全条目" prop="SJXJTM">
                <span v-show="!edit">{{ ruleForm.SJXJTM }}</span>
              <el-select v-show="edit" v-model="ruleForm.SJXJTM" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  >
                </el-option>
              </el-select>
            </el-form-item>
            </div></el-col>
        </el-row>
       
        <el-row :gutter="20">
          <el-col :offset="1" :span="20"><div class="grid-content bg-purple">
            <el-form-item label="安全条目内容" prop="XJTMNR">
                <span  v-show="!edit">{{ ruleForm.XJTMNR }}</span>
                <el-input
                  v-show="edit"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="ruleForm.XJTMNR">
                </el-input>            
            </el-form-item>
            </div></el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :offset="1" :span="20"><div class="grid-content bg-purple">
            <el-form-item label="整改内容" prop="XJTMZGFF">
                <span  v-show="!edit">{{ ruleForm.XJTMZGFF }}</span>
                <el-input
                  v-show="edit"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="ruleForm.XJTMZGFF">
                </el-input>            
            </el-form-item>
            </div></el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :offset="1" :span="20"><div class="grid-content bg-purple">
            <el-form-item label="备注" prop="BZ">
                <span  v-show="!edit">{{ ruleForm.BZ }}</span>
                <el-input
                  v-show="edit"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="ruleForm.BZ">
                </el-input>            
            </el-form-item>
            </div></el-col>
        </el-row>

         <el-row :gutter="20">
          <el-col :offset="1" :span="11"><div class="grid-content bg-purple">
            <el-form-item label="是否启用" prop="QYBZ">
                <span v-show="!edit" v-if="ruleForm.QYBZ==1">
                  启用</span>
                  <span v-show="!edit" v-else>
                  禁用</span>
                    <el-radio-group v-model="ruleForm.QYBZ" v-show="edit">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">不启用</el-radio>
                    </el-radio-group>
            </el-form-item>
            </div></el-col>
          <el-col :span="11" ><div class="grid-content bg-purple">
             <el-form-item label="是否删除" prop="SCBZ">
                <span v-show="!edit" v-if="ruleForm.SCBZ==1">
                  删除</span>
                  <span v-show="!edit" v-else>
                  正常</span>
                <div>
                <el-radio-group v-model="ruleForm.SCBZ" v-show="edit">
                      <el-radio :label="1">删除</el-radio>
                      <el-radio :label="0">正常</el-radio>
                    </el-radio-group>
              </div>           
             </el-form-item>
            </div></el-col>
        </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    ruleForm:Object,
    edit: Boolean,
  },
  data(){
    return{
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
